
import { defineComponent } from 'vue';
import Servicio from '@/services/Weather';
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import Banner from '@/components/Banner.vue';
import Search from '@/components/Search.vue';
import Weather from '@/components/Weather.vue';

export default defineComponent({
  name: 'Home',
  // Mis componentes
  components: {
    'app-header': Header,
    'app-footer': Footer,
    'app-banner': Banner,
    'app-weather-search': Search,
    'app-weather-results': Weather,
  },
  // Mis datos
  data: () => ({
    // Título de la App
    title: 'Vue Weather App',
    // Mensaje del Footer
    footerMessage: 'joseluisgs 2021',
    // Mensaje del banner
    messageToDisplay: '',
    // Tipo del banner (Info, Success o Error)
    messageType: 'Info',
    // Objeto de información meteorológica openweathermap.org
    weatherData: {
      city: '',
      weatherSummary: '',
      weatherDescription: '',
      currentTemperature: 0.0,
      highTemperature: 0.0,
      lowTemperature: 0.0,
    },
    // Nos indica si los datos se han cargado
    validWeatherData: false,
  }),
  // Ciclo de validate
  // Al crearme
  created() {
    // comprobamos la API KEY
    if (!Servicio.getKey()) {
      this.messageType = 'Error';
      this.messageToDisplay = 'Error! No OpenWeather.org API KEY';
    }
  },
  // Mis métodos
  methods: {
    // Limpia el banner
    clearMessage() {
      this.messageToDisplay = '';
      this.messageType = 'Info';
    },
    // Busca una ciudad. Maneja el evento search-city
    async searchCity(inputCity: string) {
      // Obtenemos la respuesta
      try {
        const response = await Servicio.getInfo(inputCity);
        // Respuesta correcta
        this.messageType = 'Success';
        this.messageToDisplay = `Success! Meto Info from ${response.name}`;
        // Procesamos los datos
        this.weatherData.city = response.name;
        this.weatherData.weatherSummary = response.weather[0].main;
        this.weatherData.weatherDescription = response.weather[0].description;
        this.weatherData.currentTemperature = response.main.temp;
        this.weatherData.lowTemperature = response.main.tempMin;
        this.weatherData.highTemperature = response.main.tempMax;
        this.validWeatherData = true;
      } catch (error) {
        // Si hay error
        this.messageType = 'Error';
        this.messageToDisplay = `ERROR! Can't find info from ${inputCity}!`;
        console.log(error.message);
        // this.resetData();
      } finally {
        console.log('¡HTTP GET Listo!');
      }
    },
    // Limpia los datos
    resetData() {
      this.weatherData = {
        city: '',
        weatherSummary: '',
        weatherDescription: '',
        currentTemperature: 0.0,
        lowTemperature: 0.0,
        highTemperature: 0.0,
      };
      this.validWeatherData = false;
      this.messageType = 'Info';
      this.messageToDisplay = '';
    },
  },
});
